__turbopack_context__.v({
  "alert": "InscriptionCard-module__Tl3DTG__alert",
  "body": "InscriptionCard-module__Tl3DTG__body",
  "cardShell": "InscriptionCard-module__Tl3DTG__cardShell",
  "content": "InscriptionCard-module__Tl3DTG__content",
  "contentWrapper": "InscriptionCard-module__Tl3DTG__contentWrapper",
  "footer": "InscriptionCard-module__Tl3DTG__footer",
  "link": "InscriptionCard-module__Tl3DTG__link",
  "linkShell": "InscriptionCard-module__Tl3DTG__linkShell",
  "pfpButton": "InscriptionCard-module__Tl3DTG__pfpButton",
  "previewMask": "InscriptionCard-module__Tl3DTG__previewMask",
  "previewMedia": "InscriptionCard-module__Tl3DTG__previewMedia",
  "root": "InscriptionCard-module__Tl3DTG__root",
  "row": "InscriptionCard-module__Tl3DTG__row",
  "satsWarning": "InscriptionCard-module__Tl3DTG__satsWarning",
  "subtitle": "InscriptionCard-module__Tl3DTG__subtitle",
  "warningLabel": "InscriptionCard-module__Tl3DTG__warningLabel",
});
